import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const section = css`
  position: relative;
`
const commonPadding = css`
  padding: 0 ${size[24]};

  ${breakpoint.up('smMd')} {
    padding: 0 ${size[64]};
  }

  ${breakpoint.up('lg')} {
    padding: 0;
  }
`

export const container = css`
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  overflow-x: scroll;
  display: flex;
  gap: ${size[16]};
  margin-top: ${size[32]};

  ${breakpoint.up('smMd')} {
    gap: ${size[32]};
  }

  ${breakpoint.up('lg')} {
    margin-top: ${size[64]};
    justify-content: safe center;
  }

  ${commonPadding};

  @media (hover: hover) {
    scroll-snap-type: none;
    cursor: grab;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
    }
  }
`

export const title = css`
  font-size: ${pxToRem(28)};
  line-height: 114%;
  letter-spacing: 0.02em;

  ${breakpoint.up('smMd')} {
    text-align: center;
    font-size: ${pxToRem(48)};
  }

  ${commonPadding};
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const article = (theme: Theme) => css`
  scroll-snap-align: center;
  scroll-snap-stop: always;
  padding: 15px ${size[12]};
  border: 1px solid ${theme.palette.ghost.mediumContrast};
  border-radius: 10px;
  user-select: none;

  ${breakpoint.up('smMd')} {
    max-width: 400px;
    padding: ${size[20]};
  }
`
export const picture = css`
  display: block;
  width: 232px;

  ${breakpoint.up('smMd')} {
    margin: auto;
    width: 300px;
  }

  img {
    user-select: none;
    pointer-events: none;
    border-radius: 10px;
    margin-bottom: 30px;

    ${breakpoint.up('smMd')} {
      margin-bottom: ${size[40]};
    }
  }
`

export const headline = css`
  padding: 0 15px;
  letter-spacing: 0.02em;
  text-align: center;
  line-height: 114%;
  ${breakpoint.up('smMd')} {
    padding: 0 ${size[20]};
  }
`
export const controls = css`
  display: none;

  ${breakpoint.up('smMd')} {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    max-width: 1920px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 ${size[20]};
    pointer-events: none;
    margin: auto;
  }
`

export const controlButton = css`
  display: none;

  ${breakpoint.up('smMd')} {
    display: block;
    background: #fff;
    box-shadow: 0 ${size[8]} ${size[32]} rgba(36, 34, 42, 0.12);
    pointer-events: all;

    svg path {
      transition: 0.4s;
      fill: #655368ff;
    }

    &:hover {
      svg path {
        fill: #3bbab2ff;
      }
    }
  }
`

export const controlButtonNext = css`
  ${breakpoint.up('smMd')} {
    transform: rotate(180deg);
  }
`
